angular.module('ordersSubscriptionAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/orders-subscription-add/orders-subscription-add.module.js